import axios from 'axios';
import config from '@/config';

export default {

  getVehicles(lng, lat) {
    return new Promise(function(resolve, reject) {
      axios.get(config.api + '/public/nearby-drivers', {
        params: {
          coordinateType: 'GCJ02',
          longitude: lng,
          latitude: lat
        }
      }).then(function(response) {
        // console.log(response);
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, vehicles: rs.result });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getProgressVehicle(orderId) {
    return new Promise(function(resolve, reject) {
      axios.get(config.api + '/customer/get-driver-location', {
        params: {
          coordinate_type: 'GCJ02',
          order_number: orderId
        }
      }).then(function(response) {
        // console.log(response);
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, vehicle: rs.result });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  }
};
